var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.578,
    height: 29.764,
    viewBox: "0 0 29.578 29.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12279",
    "data-name": "Group 12279",
    transform: "translate(-830.111 -203.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Your_Order",
    "data-name": "Your Order",
    transform: "translate(828.701 205.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22059",
    "data-name": "Path 22059",
    d: "M26.843,1.5H2.158a.448.448,0,0,0-.448.448V27.008a.448.448,0,0,0,.448.448H26.843a.448.448,0,0,0,.448-.448V1.948A.448.448,0,0,0,26.843,1.5ZM26.4,5.08H16.738V2.4H26.4Zm-13.238.9h2.685V13.4l-1.029-1.02a.43.43,0,0,0-.627,0L13.157,13.4ZM15.843,2.4V5.08H13.157V2.4ZM2.605,2.4h9.657V5.08H2.605ZM14.948,26.561V20.3h2.685v6.265Zm7.16,0V20.3h2.685v6.265Zm4.287,0h-.707V19.848a.448.448,0,0,0-.448-.448H21.66a.448.448,0,0,0-.448.448v6.713H18.528V19.848a.448.448,0,0,0-.448-.448H14.5a.448.448,0,0,0-.448.448v6.713H2.605V5.975h9.657v8.5a.448.448,0,0,0,.277.412.421.421,0,0,0,.483-.1L14.5,13.323l1.477,1.468a.421.421,0,0,0,.313.134.385.385,0,0,0,.17,0,.448.448,0,0,0,.277-.448v-8.5H26.4Z",
    stroke: "#000",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 7,
    cy: 7,
    rx: 7,
    ry: 7,
    transform: "translate(844.395 204.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(843.202 203.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.834,6.636,3.687,7.783,7.374,11.47l8.193-8.193L14.42,2.13,7.374,9.176l-2.54-2.54Zm9.914,1.557A6.555,6.555,0,1,1,8.193,1.639a6.39,6.39,0,0,1,1.8.246L11.307.574A9.972,9.972,0,0,0,8.193,0a8.193,8.193,0,1,0,8.193,8.193Z",
    stroke: "#000",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionApproved);
export default __webpack_public_path__ + "static/media/Subscription-Approved.40da413d6617bb478500651ae3a561a9.svg";
export { ForwardRef as ReactComponent };